$(function() {
  const $banner = $('#js-qr-banner');
  const $closeBtn = $('#js-qr-banner__close');
  let isClosed = false;

  // 閉じる処理
  $closeBtn.on('click', (e) => {
    e.preventDefault();
    $banner.addClass('is-hidden');
    isClosed = true;
  });

  // 表示判定処理
  const toggle = () => {
    if (isClosed) return;
    const show = $(window).width() <= 768 && $(window).scrollTop() > 100;
    $banner.toggleClass('is-visible', show);
  };

  $(window).on('scroll resize', toggle);
  toggle(); // 初期実行
});

